import { inject, reactive } from "vue";

export default function semanticVersion() {
  const moment = inject("$moment");

  // Format any date in Philippine Time
  const versionHistory = reactive([
    {
      version: "1.0.3",
      description: "Fixed transaction history status",
      releasedDate: moment("2026-11-03").format("LLL"),
    },
    {
      version: "1.0.2",
      description: "Changes LOGs Company Address",
      releasedDate: moment("2026-10-12").format("LLL"),
    },
    {
      version: "1.0.1",
      description: "Modified Terms and Condition",
      releasedDate: moment("2026-03-09").format("LLL"),
    },
    {
      version: "1.0.0",
      description: "Initial Released",
      releasedDate: moment("2026-03-03").format("LLL"),
    },
  ]);

  return {
    versionHistory,
  };
}
